/* GLOBAL PLUGINS */
(function ($) {
	$.extend({
		getUrlToken: function (rawurl) 
		{ 
			let baseUrl = window.location.origin; 
			let url = new URL(rawurl, baseUrl); 
			let token = $.getToken();
			url.searchParams.set(token, 1);
			return url.toString();
		}
	});
})(jQuery);
(function ($) {
	$.extend({
		getToken: function () {
			return $('#platform-token').val();
		}
	});
})(jQuery);
 

/*SETUP BACKGROUND */

$(document).ready(function() {
	$('[data-background]').each(function() 
	{
		 
		var url 	= $(this).attr('data-background');
		 
		$(this).css('background-image', 'url(' + url + ')');
	});
});

$(document).ready(function() {
	if ( $( "#no-banner" ).length ) 
	{
		$('#main-menu').addClass('reactive'); // Hides the element
	}	
});

/* TOGGLE */
$(document).ready(function() 
{
	if ( $( ".toggle-checkbox" ).length ) 
	{
		$("body").on("click", ".toggle-checkbox", function(event){
			var check 	= $(this).prop('checked');
			var target 	= $(this).attr('data-target');
			
			if (check) 
			{
				$(target).addClass('d-block').removeClass('d-none');
			 
			}
			else
			{
				$(target).removeClass('d-block').addClass('d-none');
			}
		});
		
	}	
});
/* FILTER SELECTION OF TRANSPORTATION */
$(document).ready(function() {
	$("body").on("change", ".filter-transportation-method", function() {
		var target		= $(this).data('target');
		var selection	= $(this).val() ;
		
		if (selection == 1) 
		{
			 $(target).slideUp();
		}
		else
		{
			$(target).slideDown();
		}
		
		
	 
	});
});
/* SWIPER*/

$(document).ready(function() {
	
	if ( $( ".overflow-slider" ).length ) 
	{
		$(".overflow-slider").each(function(index) {
			
			var $this 			= $(this); 
			var pagination 		= $this.data('pagination') 	|| 'swiper-pagination';
			var swiper 			= new Swiper($this[0], {
				slidesPerView: 1,
				spaceBetween: 10, 
				grabCursor: true,
				pagination: { el: '.'+pagination, clickable: true, },
				breakpoints: 
				{
					640: 
					{
						slidesPerView: 1,
						spaceBetween: 10,
					},
					768: 
					{
						slidesPerView: 2,
						spaceBetween: 30,
					},
					1024: 
					{
						slidesPerView: 3,
						spaceBetween: 30,
					},
				},
			});
		});
	}	
	
	 
	
	if ( $( ".cover-one-slider" ).length ) 
	{
		var swiper = new Swiper(".cover-one-slider", {
			effect:'coverflow',
			slidesPerView: "auto",
			loop: false,
			centeredSlides: true,
			spaceBetween: 60, 
			grabCursor: true,
			coverflow: 
			{
				rotate: 0,
				stretch: 0,
				depth: 0,
				modifier: 0,
				slideShadows: true,
				loop: true,
			}, 
			navigation: 
			{
				nextEl: ".one-next",
				prevEl: ".one-prev"
			}, 
			breakpoints: {
				640: {
					slidesPerView: 2, 
				},
				1024: {
					slidesPerView:"auto", 
				},
			},
		});
	}	
	
	if ( $( ".swiper-default" ).length ) 
	{	
		$(".swiper-default").each(function(index) {
			var $this 			= $(this); 
			var btnPrev 		= $this.data('nav-prev') 	|| 'swiper-button-prev';
			var btnNext 		= $this.data('nav-next') 	|| 'swiper-button-next';
			var pagination 		= $this.data('pagination') 	|| 'swiper-pagination';
			var effect 			= $this.data('effect') 		|| 'slide';
			var space 			= $this.data('space') 		|| 10;
			var loop 			= $this.data('loop') 		|| false;
			var centeredSlides	= $this.data('center-slide')|| false;
			 
			if ($this.children().length) {
				var swiper = new Swiper($this[0], { 
					slidesPerView: 1,
					effect:effect,
					centeredSlides:centeredSlides,
					spaceBetween: space,
					loop: loop,
					grabCursor: true,
					pagination: { el: '.'+pagination, clickable: true, },
					navigation: { nextEl: '.'+btnNext, prevEl: '.'+btnPrev,},
					breakpoints: {
						640: {
							slidesPerView: 2,
							spaceBetween: space,
						},
						1024: {
							slidesPerView: 4,
							spaceBetween: space,
						},
					},
				});
			} 
		});
		
	}	
});



/* NEWSLETTER SUBSCRIBE */
$("body").on("click", ".btn-subscribe-newsletter", function() {
	var url 			= $(this).data('url'); 
	var email 			= $('#subscribe-email').val();
	var emailValidate = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	if (url && email && emailValidate.test(email)) 
	{
		 
		$.ajax({
			url: $.getUrlToken(url),
			type: 'POST',
			dataType: 'json', 
			data: {email:email},
			success: function(response) {
				if (response.status) {
					$('#subscribe-email').val('');
					Swal.fire({
						title: "Subscription Confirmed",
						text: response.message,
						icon: "success", 
						confirmButtonText: "Close",
						buttonsStyling: false, 
						customClass: 
						{
							confirmButton: 'btn btn-success', 
						}
					});
				} else { $.toast('Error', response.message, 'error'); }
			},
			error: function(xhr, status, error) { console.error(xhr, status, error); }
		});
	} else if (!emailValidate.test(email)) { $.toast('Subscription Email Format Invalid' , 'Your given email address format is invalid', 'error'); }
});
 

$(document).ready(function() 
{
AOS.init({});
});
$(document).ready(function() 
{
 	if ( $( ".append-body-class" ).length ) 
	{
		let url = $( ".append-body-class" ).attr('data-class');
		$('body').addClass(url);
	}	
});
(function ($) {
	$.extend({
		reloadMenu: function () 
		{
			 var introMediaHeight = $('.main-banner').height();
			 
			if ($(window).scrollTop() > 40)
			{
				$('#header-quick-menu').slideUp(); // Hides the element
			}
			else 
			{
				$('#header-quick-menu').slideDown(); // Shows the element when scrolled up
			}
			if ($(window).scrollTop() > introMediaHeight)
			{
				$('#main-menu').addClass('active'); // Hides the element
			}
			else 
			{
				$('#main-menu').removeClass('active'); // Hides the element
			}
		}
	});
})(jQuery);

$(document).ready(function() 
{
	$(window).on('scroll', function() 
	{
		$.reloadMenu();
	});
	$.reloadMenu();
});

	// $(document).ready(function() 
	// {
		// var introMediaHeight = $('#header-intro-media').height();
		
		// $(window).on('scroll', function() 
		// {
			// if ($(window).scrollTop() > 100)
			// {
				// $('#top-header-menu').slideUp(); // Hides the element
				// $('#primary-header-menu').addClass('background-blur'); // Hides the element 
				// $('#menu-logo').removeClass('opacity-0');
			// }
			// else 
			// {
				// $('#top-header-menu').slideDown(); // Shows the element when scrolled up
				// $('#primary-header-menu').removeClass('background-blur'); // Hides the element
				// $('#menu-logo').addClass('opacity-0');
			 
			// }
		// });
		// $(window).on('scroll', function() {
			// if ($(window).scrollTop() > (introMediaHeight-20)) {
				 
				// $('#primary-header-menu').addClass('background-blur-inverse'); // Hides the element
				// $('.navbar-brand').removeClass('text-white'); // Hides the element
			// } else {
		 
				// $('#primary-header-menu').removeClass('background-blur-inverse'); // Hides the element
				// $('.navbar-brand').addClass('text-white'); // Hides the element
			// }
		// });
		
 
	// });

$(document).ready(function() 
{
	$("body").on("click", "[force-autocomplete-off]", function(event){
		$(this).removeAttr('readonly');
		$(this).focus();
	}); 
});

/* Toast Global */
	(function ($) {
		$.extend({
			toast: function (title,message,theme) {
				var ts 			= new Date().getTime();
				var toastObject		= {};
				toastObject.id			= 'toast-'+ts;
				toastObject.title		= title;
				toastObject.message	= message;
				toastObject.theme		= theme;
				
				if (toastObject.theme) 
				{
					if (toastObject.theme == 'success' ) 
					{ 
						toastObject.icon		= 'check-circle';
					}
					else if (toastObject.theme == 'error' || toastObject.theme == 'danger' ) 
					{ 
						toastObject.icon		= 'slash';
						toastObject.theme		= 'danger';
					}
					else if (toastObject.theme == 'primary' ) 
					{ 
						toastObject.icon		= 'bell';
					}
					else if (toastObject.theme == 'info' ) 
					{ 
						toastObject.icon		= 'info';
					}
					else if (toastObject.theme == 'warning' ) 
					{ 
						toastObject.icon		= 'alert-triangle';
					}
					else
					{
						toastObject.icon		= 'info';
						toastObject.theme		= 'dark';
					}
				}
				else
				{
					toastObject.icon		= 'info';
					toastObject.theme		= 'dark';
				}
			
				$('#toast-component').append(Mustache.render($.loadTemplate('toast-template'), { data: toastObject }));
				var toastitem = new bootstrap.Toast($('#'+toastObject.id), {data:toastObject}).show();
			}
		});
	})(jQuery);
/* Loading Mustache Template */
	(function ($) {
		$.extend({
			loadTemplate: function (template_id) {
				
				if ( $('#'+template_id).length ) 
				{
					var tmpl	= $('#'+template_id).html();
					tmpl		= tmpl.replace(new RegExp('src="/{', 'g'),'src="{');
					tmpl		= tmpl.replace(new RegExp('href="/{', 'g'),'href="{');
					tmpl		= tmpl.replace(new RegExp('/{{image}}', 'g'),'{{image}}');
				}	
				return tmpl;
			}
		});
	})(jQuery);
	$.fn.jsLoaded = function(param) 
	{
		if ($(this).attr('js-loaded')){ return 0; }else
		{ 
			$(this).attr('js-loaded','loaded')
			return 1;
		}
	}; 
	
	
	
	$(document).ready(function() 
	{
		if ( $( ".data-form" ).length ) 
		{ 
			$( ".data-form" ).each(function( index ) {
				if($(this).jsLoaded())
				{ 
					$(this).validate({ 
					ignore: [],
					errorPlacement: function ( error, element ) 
					{
						
						if(element.parents().hasClass('input-validate'))
						{
							error.insertAfter( element.closest('.input-validate') );
						} 
						else if(element.parent().hasClass('input-group'))
						{
							error.insertAfter( element.parent() );
						}
						else if(element.hasClass('form-select') && element.next('.select2-container').length) 
						{
							error.insertAfter(element.next('.select2-container'));
						}
						else
						{
							error.insertAfter( element );
						} 
					}, 
					errorClass: 'form-error-msg',
					errorElement: 'div',
					});
				}
			});
		} 
	});
	
	
	
/* on Rate page search submit button on search date*/
$(document).ready(function() 
{ 

	$("body").on("click", "#btn-rate-search", function(event){
		var url 			= $(this).data('url');
		var checkin 		= $(this).attr('data-check-in');
		var checkout 		= $(this).attr('data-check-out');
		var rate 			= $(this).data('rate');
		var required		= $(this).data('required');
		
		// console.log(checkin);
		// console.log(checkout);
		// console.log(rate);
	 
		if (checkin && checkout && checkin != '-' && checkout != '-') 
		{ 
			var queryString = $.param({ check_in_date: checkin, check_out_date: checkout, rate: rate });

			if (url.includes('?')) { url += '&' + queryString; } else { url += '?' + queryString; }
			window.location.href = url;
		}
		else
		{ 
			Swal.fire({ 
				text: required,
				icon: "info", 
				confirmButtonText: "OK",
				buttonsStyling: false, 
				customClass: 
				{
					confirmButton: 'btn btn-lg btn-round solid', 
				}
			}).then((result) => { });
		}
	});
	if ($(".inline-calender").length) 
	{
		$(".inline-calender").each(function(index) 
		{
			try 
			{ 
			 
				var suggestPrice 	= JSON.parse($(this).attr('data-suggest-price') || '{}');
				var disabledDates 	= JSON.parse($(this).attr('data-disabled-date') || '{}');
				var minDate 		= $(this).data('min-date') || 'today';
				var maxDate 		= $(this).data('max-date') || 'today';
				var nights 			= $(this).data('nights') || 1;

				var fp = flatpickr(this, {
				mode: "range",
				inline: true,
				minDate: minDate,
				maxDate: maxDate,
				dateFormat: "Y-m-d",
				disable: Object.keys(disabledDates), 
				onClose: function(selectedDates, dateStr, instance) 
				{
					if (selectedDates.length === 2) 
					{
						const startDate 	= selectedDates[0];
						const endDate 		= selectedDates[1];
						const dayDifference = (endDate - startDate) / (1000 * 60 * 60 * 24);
	 
						const startTime 	= startDate.getTime();
						const endTime 		= endDate.getTime();
						let hasDisabledDate = false;

						for (const date in disabledDates) 
						{
							const disabledTime = new Date(date).getTime();
							if (disabledTime >= startTime && disabledTime <= endTime) 
							{
								hasDisabledDate = true;
								break;
							}
						}

						if (hasDisabledDate) 
						{
							$('#btn-rate-search').attr('data-check-in',"-");
							$('#btn-rate-search').attr('data-check-out',"-");
							$.toast('Warning', 'Choosn date is not available', 'warning');
							instance.clear(); 
							return;
						}

						if (dayDifference < nights) 
						{
							
							$('#btn-rate-search').attr('data-check-in',"-");
							$('#btn-rate-search').attr('data-check-out',"-");
							$.toast('Information', 'Minimun '+nights+' nights is required', 'info');
							instance.clear(); 
							return;
						}

						const syear		= startDate.getFullYear();
						const smonth 	= (startDate.getMonth() + 1).toString().padStart(2, '0'); 
						const sday 		= startDate.getDate().toString().padStart(2, '0');

						const eyear		= endDate.getFullYear();
						const emonth 	= (endDate.getMonth() + 1).toString().padStart(2, '0'); 
						const eday 		= endDate.getDate().toString().padStart(2, '0');

						var inDate 	= syear+'-'+smonth+'-'+sday;
						var outDate 	= eyear+'-'+emonth+'-'+eday;


						$('#btn-rate-search').attr('data-check-in',inDate);
						$('#btn-rate-search').attr('data-check-out',outDate);


					} 
				},
				onDayCreate: function(dObj, dStr, fp, dayElem) 
				{
					var year 	= dayElem.dateObj.getFullYear();
					var month 	= (dayElem.dateObj.getMonth() + 1).toString().padStart(2, '0');
					var day 	= dayElem.dateObj.getDate().toString().padStart(2, '0');

					var dateStr 		= `${year}-${month}-${day}`; 
					var displayDay		 = dayElem.dateObj.getDate(); 

					var display_suggest_price 	= suggestPrice[dateStr] ? '<div>'+suggestPrice[dateStr]+'</div>' : "";
					dayElem.innerHTML 			= '<div class="extra-content"><strong>'+displayDay+'</strong>'+display_suggest_price+'</div>';
				}
				});
				fp.clear();
				fp.setDate(null);
			 
			} catch (e) { console.error("Error parsing JSON data attributes: ", e); }
		});
	}
	
	$("body").on("click", "#btn-clear-search", function(event){
		const instance = document.querySelector("#inline-calender")._flatpickr;
		instance.clear();       
	});


});
	

/* on Search page*/
function toggleDropdown() 
{
	var dropdown			= document.getElementById("dropdownContent");
	var packageSelected		= document.querySelector(".package-selected");
	dropdown.style.width 	= packageSelected.offsetWidth + "px";
	dropdown.style.display 	= (dropdown.style.display === "block") ? "none" : "block";
}
window.onclick = function(event) 
{ 
	if (!event.target.closest('.package-selected') && !event.target.closest('.dropdown-package-content')) 
	{
		var dropdowns = document.getElementsByClassName("dropdown-package-content");
		for (var i = 0; i < dropdowns.length; i++) 
		{
			var openDropdown = dropdowns[i];
			
			if (openDropdown.style.display === "block") 
			{
			openDropdown.style.display = "none";
			}
		}
	}
};
// $(document).ready(function() 
// {
	// $("body").on("click", ".reselect-rate", function(event)
	// {
		// var name 	= $(this).attr('data-name');
		// var value 	= $(this).attr('data-value');

		// $('#rate_id').val(value);
		// $('#rate_name').html(name);
		// var dropdown = document.getElementById("dropdownContent");
		// if (dropdown) 
		// {
			// dropdown.style.display = "none";
		// }
	// });
// });
 

$(document).ready(function() 
{
	var masterSelected = []; 
	if ( $( "#masterSelected" ).length ) 
	{
		if ( $( ".rate-refresh" ).length ) 
		{
			setTimeout(function()
			{ 
				$( ".rate-refresh" ).each(function( index ) {
					$(this).trigger('change');
				});
			}, 300);
		}	
		$("body").on("click", ".btn-proceed-booking-guest", function(event){
			var totalRooms	= parseInt($.getTotalUnitSelected());
			if (totalRooms > 0 ) 
			{
				var masterSelected = $('#masterSelected').val();
				if (masterSelected) 
				{
					var form = $('#mainRoomSelection') ;
				 
					form.submit(); 
				}
			}
		});
		$("body").on("click", "[data-charge]", function(event){
			var html 		= '';
			var row 		= $(this).closest('.rate-list');
			var charge 		= $(this).data('charge');
			var adText 		= $(this).data('type-adult');
			var chText 		= $(this).data('type-child');
			var ifText 		= $(this).data('type-infant');
			
			if (charge.adult) 
			{
				html +='<div class="row"> <div class="col-sm-12 fs-5 fw-medium"> '+adText+' </div> </div>';;
				$.each(charge.adult, function(key,value) {
					if (value.price) 
					{
						var tt = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value.price);
						html += '<div class="row border-bottom"> <div class="col-sm-6"> '+value.title+' </div> <div class="col-sm-6 text-end"> '+tt+' </div> </div>';
					}
				}); 
			}
			if (charge.adult_total) 
			{ 
				var tt = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(charge.adult_total.price);
				html += '<div class="row border-bottom"> <div class="col-sm-6"> '+charge.adult_total.title+' </div> <div class="col-sm-6 text-end"> '+tt+' </div> </div>';
			}
			if (charge.child) 
			{
				html +='<div class="row mt-4"> <div class="col-sm-12 fs-5 fw-medium"> '+chText+' </div> </div>';;
				$.each(charge.child, function(key,value) {
					if (value.price) 
					{
						var tt = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value.price);
						html += '<div class="row border-bottom"> <div class="col-sm-6"> '+value.title+' </div> <div class="col-sm-6 text-end"> '+tt+' </div> </div>';
					}
				}); 
			}
			
			if (charge.child_total) 
			{ 
				var tt = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(charge.child_total.price);
				html += '<div class="row border-bottom"> <div class="col-sm-6"> '+charge.child_total.title+' </div> <div class="col-sm-6 text-end"> '+tt+' </div> </div>';
			}
			
			var infantChecked	= row.find('.with-infant');
			var infant 			= 0 ;
			
			if (infantChecked.length) 
			{
				 if (infantChecked.prop('checked')) 
				 {
					 var infantSelectUnit = row.find('.form-select-infant'); 
					 
					 if (infantSelectUnit.length) 
					 { 
						 var selectedValue = parseInt(infantSelectUnit.val());
						 
						 if (selectedValue > 0 ) 
						 {
							infantPrice 	= infantSelectUnit.find('option:selected').data('total-infant');
								 
							if (infantPrice) 
							{ 
								infant = infantPrice;
								html +='<div class="row mt-4"> <div class="col-sm-12 fs-5 fw-medium"> '+ifText+' </div> </div>';;
								var tt = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(infantPrice);
								html += '<div class="row border-bottom"> <div class="col-sm-6"> '+selectedValue+' <i class="fal fa-fw fa-times"></i> '+ifText+'</div> <div class="col-sm-6 text-end"> '+tt+' </div> </div>';
							}
						 }
					 }
				 } 
			}
			if (charge.all_total) 
			{
				var alltotal = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(charge.all_total)+parseFloat(infant));
				html +='<div class="row mt-4"> <div class="col-sm-12 fs-3 fw-medium text-end">RM '+alltotal+' </div> </div>';;
			}
			$('#charge-details').html(html);
		});
		(function ($) {
			$.extend({
				getTotalUnitSelected	: function () {
					if ( $( ".rate-list" ).length ) 
					{
						var quantity = 0; 
						$( ".rate-list" ).each(function( index ) 
						{ 
							var select			= $(this).find('.select-room-unit').val();;
							if (select > 0) { quantity = quantity + parseInt(select); }
						});
						
						return (quantity); 
					}	
				}
			});
		})(jQuery);
		(function ($) {
			$.extend({
				refreshCategory: function () {
					
					var selectedCatgory = $('.filter_room_category:checked').map(function() { return $(this).attr('id'); }).get(); 

					$( ".main-room-category" ).each(function( index ) {
						var element = $(this);
	 
						var hasMatchingClass = selectedCatgory.some(function(category) { return element.hasClass(category); });

						if (hasMatchingClass) 
						{ 
						
							var roomType 	= $(this).find('.rate-category'); 
							var active 		= $(this).find('.rate-category').filter('.d-block');
							
							if (active.length <= 0 ) 
							{
								 $(this).addClass('d-none').removeClass('d-block');
							}
							else
							{
								 $(this).removeClass('d-none').addClass('d-block');
							} 
						} 
					});
				}
			});
		})(jQuery);
		(function ($) {
			$.extend({
				refreshPrice: function (row) 
				{
					var rowId 			= row.data('list-id');
					var baseRate		= row.data('base-rate');
					var infantChecked	= row.find('.with-infant');
					var roomPriceLabel	= row.find('.total-room-price');;
					roomPriceLabel.attr('data-price',0);
					var totalDeal		= 0;;
					var infantPrice		= 0;;
					 
					if (infantChecked.length) 
					{
						 if (infantChecked.prop('checked')) 
						 {
							 var infantSelectUnit = row.find('.form-select-infant'); 
							 
							 if (infantSelectUnit.length) 
							 {
								 var selectedValue = infantSelectUnit.val();
								 infantPrice 	= infantSelectUnit.find('option:selected').data('total-infant');
							 }
						 } 
					}

					totalDeal = parseFloat(baseRate) + parseFloat(infantPrice);
					roomPriceLabel.attr('data-price',totalDeal);
					var formattedTotalDeal = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(totalDeal);
					roomPriceLabel.html(formattedTotalDeal);
					$.refreshSelection();
				}
			});
		})(jQuery);
		(function ($) {
			$.extend({
				refreshSelection: function () {
					if ( $( ".rate-list" ).length ) 
					{ 
						var total = 0;
						var list = '';
						$('#selected-plan').empty();
						 masterSelected = []; 
						$( ".rate-list" ).each(function( index ) 
						{
							var parent			= $(this).closest('.rate-category');
							var category			= parent.data('list-category');
							var roomPriceLabel	= $(this).find('.total-room-price');;
							var select			= $(this).find('.select-room-unit').val();;
							var item_id			= $(this).find('.select-room-unit').attr('data-item-id');;

							if (select > 0) 
							{ 
								var rowId					= $(this).data('list-id');
								var selectedCategory		= $(this).data('category');
								var selectedOccupancy		= $(this).data('occupancy');
								var selectedAdult			= $(this).data('adult');
								var selectedChild			= $(this).data('child');
								var selectedUnit			= select;
								var selectedItemId			= item_id;
								var infantSelectUnit 		= $(this).find('.form-select-infant');
								var selectedInfant 			= 0;

								if ($(this).find('.with-infant').prop('checked') && infantSelectUnit.length)
								{
									var selectedValue = parseInt(infantSelectUnit.val());
									if (selectedValue > 0) 
									{
										selectedInfant = selectedValue;
									}
								}
									 
								masterSelected.push({
									key: selectedItemId,
									category: selectedCategory,
									occupancy: selectedOccupancy,
									unit: selectedUnit,
									infant: selectedInfant,
									adult: selectedAdult, 
									child: selectedChild
								}); 
								
								total = total + parseFloat(roomPriceLabel.attr('data-price'))*select;
							}
						});
						if (isNaN(total) || total <= 0 || total === '') { total = 0.00; }
						var encodedMasterSelected = JSON.stringify(masterSelected);
	 
						$('input[id="masterSelected"]').val(encodedMasterSelected);
						parseFloat(total) > 0 ? $('#total-container').slideDown() : $('#total-container').slideUp();

						var formattedTotalDeal = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total);
						$('#selected-plan').append('<div class="fs-3 text-white text-end">'+formattedTotalDeal+'</div>');
					}	
				}
			});
		})(jQuery);
		$("body").on("change", ".form-select-infant,.with-infant", function(event){
			var row 			= $(this).closest('.rate-list');
			$.refreshPrice(row);
		});
		$("body").on("change", ".select-room-unit", function(event)
		{
			var row 						= $(this).closest('.rate-list');
			var currentSelected 			= parseInt($(this).val());
			var allSelected					= parseInt($.getTotalUnitSelected());
			var beforeSelected				= allSelected-currentSelected;
			
			if (allSelected > 9) 
			{
				Swal.fire({
					title: "Room allowed per booking",
					text: "Maximum 9 Rooms is allowed per booking",
					icon: "info", 
					confirmButtonText: "OK",
					buttonsStyling: false, 
					customClass: { confirmButton: 'btn btn-round solid', }
				}).then((result) => { });
				$(this).val('0').trigger('change');
			}
			else { $.refreshPrice(row); } 
		});
		if ( $( ".filter_room_category" ).length ) 
		{
			$("body").on("click", ".filter_room_category", function(event){
				$( ".filter_room_category" ).each(function( index ) {
					var id 		= $(this).attr('id');
					var check 	= $(this).prop('checked');
					
					if (check) 
					{
						 $('.'+id).addClass('d-block').removeClass('d-none');
					}
					else
					{
					
						 $('.'+id).removeClass('d-block').addClass('d-none');
					} 
					$.refreshSelection( );
				});
				$.refreshCategory();
			});
		}	
		if ( $( ".filter_room_occupancy" ).length ) 
		{
			$("body").on("click", ".filter_room_occupancy", function(event){
				$( ".filter_room_occupancy" ).each(function( index ) {
					var id 		= $(this).attr('id');
					var check 	= $(this).prop('checked');
					
					if (check) 
					{
						 $('.'+id).addClass('d-block').removeClass('d-none');
					}
					else
					{
						 $('.'+id).removeClass('d-block').addClass('d-none');
					} 
					$.refreshSelection( );
				});
				$.refreshCategory();
			});
		}	
		if ( $( ".btn-search-again" ).length ) 
		{
			$("body").on("click", ".btn-search-again", function(event){
			
				var	form 			= $(this).closest('form');
				var mainSearchUrl 	= form.attr('action');
				var	check_in_date 	= $('#check_in_date').val();
				
				var	check_out_date 	= $('#check_out_date').val();
				var	rate_id 		= $('#rate_id').val();
				var	mainSearch 		= $('#main-search-container');
		 
				if (check_in_date && check_out_date && rate_id && mainSearchUrl) 
				{
					var queryParams = `?checkInDate=${encodeURIComponent(check_in_date)}&checkOutDate=${encodeURIComponent(check_out_date)}&rate=${encodeURIComponent(rate_id)}`;
					window.location.href = mainSearchUrl + queryParams;
				} 
			});
		}	
		if ( $( ".rate-category " ).length ) 
		{
			$( ".rate-category " ).each(function( index ) {
			var withKidsSection = $(this).find('.open-toggle');

				if ( withKidsSection.length ) 
				{
					var kidsCheck 	= $(this).find('.travel-with-kids');
					kidsCheck.prop('checked', true);
					kidsCheck.attr('aria-expanded', true);
					var tg 			= kidsCheck.data('bs-target');
					$(tg).removeClass('collapse').addClass('show');
				}	 
			});
		}	
		$.refreshSelection();
	}	
});
 
/* addon page */
$(document).ready(function() 
{
	(function ($) {
		$.extend({
			refreshAddons: function () {
				$('#addon-display').empty();
				var addonList 	= [];
				var addonTotal 	= 0;
				
				$( ".addon-item-list" ).each(function( index ) {
					var title 	= $(this).find('.addon-title').html();
					var price 	= $(this).find('.addon-price').data('price');
					var unit 	= parseInt($(this).find('.addon-unit').val());
					
					if (unit > 0 ) 
					{
						addonList.push({title: title,price: price,unit: unit,total: price*unit }) ;
						addonTotal 	= addonTotal + (price*unit);
					}
				}); 
				var baseTotal = $('#all-total').data('total');;
				var allTotal = baseTotal + addonTotal;;
				 
				var allTotal = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(allTotal));

				if ( addonList.length ) 
				{
					$.each(addonList, function(key,value) {
						var aPrice 	= new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(value.price));
						var aTotal 	= new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(value.total));
						var text 		= ' <div class="border-bottom-dashed py-2"> <div class="row d-flex align-items-center"> <div class="col-9 col-md-9"> <div class="fw-medium text-uppercase"> '+value.title+' </div> </div> <div class="col-3 col-md-3"> <div class="text-end text-uppercase fs-9"> </div> </div> <div class="col-9 col-md-7"> <div class="fs-9"> '+value.unit+' <i class="fal fa-fw fa-times"></i> '+aPrice+' </div> </div> <div class="col-3 col-md-5"> <div class="text-end text-uppercase fw-medium"> '+aTotal+' </div> </div> </div> </div> ';
						$('#addon-display').append(text);
					}); 
				}	
				$('#all-total').html(allTotal);;
			}
		});
	})(jQuery);
	$("body").on("change", ".addon-unit", function(event){
		$.refreshAddons();
	});
	
	// document.querySelectorAll('[data-mdb-select-init]').forEach(select => {
	// select.removeAttribute('data-mdb-select-init'); 
	// mdb.Select.getInstance(select)?.dispose(); / 
	// new mdb.Select(select); 
	// });

	$.refreshAddons();
}); 

/** Information page */
$(document).ready(function() 
{
	(function ($) {
		$.extend({
			revalidateForm: function (form) {
				form.find('input, select, textarea').each(function() {
					$(this).removeClass('is-valid is-invalid'); 

					if (this.checkValidity()) {
						$(this).addClass('is-valid'); 
					} else {
						$(this).addClass('is-invalid'); 
					}
				});
			}
		});
	})(jQuery);
	if ( $( "#membership-interface-modal" ).length ) 
	{
		$('#membership-interface-modal').modal('show');

		$("body").on("click", ".btn-member-login,.btn-member-register", function(event){ 

			event.preventDefault(); 
			var form 		= $(this).closest('form');
			var formData 	= form.serialize();

			$.revalidateForm(form);
			
			var valid = form[0].checkValidity();
			
			if (valid) 
			{
				$.ajax({
					type: 'POST',
					url: form.attr('action'), 
					data: formData,
					success: function(response) 
					{
						if (response.status) 
						{
							 window.location.reload(true);
						}
						else
						{
							Swal.fire({
							 
								text: response.message,
								icon: "error", 
								confirmButtonText: "OK",
								buttonsStyling: false, 
								customClass: 
								{
									confirmButton: 'btn btn-round solid', 
								}
							}).then((result) => { 	});
						}
						 
					},
					error: function(xhr, status, error) { }
				});

			}
			
		});


	}	
});

/* Payment button */

	if ( $( ".btn-proceed-initiate-payment" ).length ) 
	{
 
		var form_submitted = 0;
		$("body").on("click", ".btn-proceed-initiate-payment", function(event){
			event.preventDefault(); 
			
			 
			
			var form 		= $(this).closest('form'); 
			var init 		= form.attr('data-init');
			var formData 	= form.serialize();
			var method 		= form.find('#payment_method').val();
			var method 		= form.find('#payment_method').val();

			if (method <= 0 ) 
			{
				Swal.fire({
					title: "Payment Method",
					text: "Please choose your payment method",
					icon: "warning", 
					confirmButtonText: "OK",
					buttonsStyling: false,  
					customClass: 
					{
						confirmButton: 'btn-round solid',   
					}
				}).then((result) => { });
				return;
			}
			else  if(form_submitted == 0)
			{
				form_submitted = 1;
				
				Swal.fire({
					title: "Processing", 
					html: '<div class="pb-4"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><span class="sr-only">Loading...</span></div>',
					allowOutsideClick: false,
					allowEscapeKey: false,
					showConfirmButton: false,
				}) ; 
				
				 
				$.ajax({
					type: 'POST',
					url: init, 
					data: formData,
					success: function(response) 
					{
						  
						  
						 
						if (response.status) 
						{
							 if (response.data.code) 
							 {
								 $('#deeplink').val(response.data.deeplink);
								 $('#reference').val(response.data.code);
								 var payform = $('#payment-form');
								 payform.submit(); 
							 }
						}
						else
						{
							Swal.fire({
							 
								text: response.message,
								icon: "error", 
								confirmButtonText: "OK",
								buttonsStyling: false, 
								customClass: 
								{
									confirmButton: 'btn btn-round solid', 
								}
							}).then((result) => { window.location.reload(true);	});
						}
						 
					},
					error: function(xhr, status, error) { }
				});
			}
		});
	}	
	
/*search booking*/

$(document).ready(function() 
{
    $("#dynamic-search-booking").on("keyup change", function() {
        let searchText = $(this).val().toLowerCase();  

        $(".booking-lists").each(function() {
            let keyword = $(this).data("keyword").toLowerCase();  

            if (keyword.includes(searchText)) {
                $(this).show();  
            } else {
                $(this).hide();  
            }
        });
    });
});

/*payment selection*/
document.addEventListener("DOMContentLoaded", function() {
	$("body").on("click", ".payment-select-item", function(event){
		var that 		= $(this);
		var thatId 		= $(this).attr('data-id'); 
		$(".payment-select-item").removeClass('active');
		$("#payment_method").val(thatId);
		that.addClass('active');
	});
});
	
	
/*enfore all english input */

$(document).ready(function () {
	// Apply to all input fields
	$('input').on('input', function () {
		// Replace any character not in the English range (ASCII) with an empty string
		const allowedCharacters = /^[\x20-\x7E]*$/; // ASCII range for printable characters
		if (!allowedCharacters.test($(this).val())) {
			$(this).val($(this).val().replace(/[^\x20-\x7E]/g, ''));
		}
	});
});

/* identification type change no expiry for malaysian*/
$(document).ready(function() 
{
	(function ($) {
		$.extend({
			refreshIdentification: function () {
				$( ".identification-type-select" ).each(function( index ) {
					
					var value 		= $(this).val();
					var container 	= $(this).closest('.pax-namelist-container').find('.identification-expiry-expiry');
					var field 		= $(this).closest('.pax-namelist-container').find('.identification-expiry-expiry-field');
					
					 
					if (value == 1) // passport
					{
						container.removeClass('d-none').addClass('d-block');
						field.attr('required','required');
					}
					else
					{
						field.removeAttr('required');
						field.val('');
						container.addClass('d-none').removeClass('d-block');
					}
					 
				}); 
			}
		});
	})(jQuery);
	$("body").on("change", ".identification-type-select", function(event){
		$.refreshIdentification();
	});
	$.refreshIdentification();
});


		document.addEventListener("DOMContentLoaded", function() {
			document.querySelectorAll('.form-outline').forEach((formOutline) => {
				new mdb.Input(formOutline).init();
			}); 
			
			(() => {
		 'use strict';
 
		 const forms = document.querySelectorAll('.needs-validation');
 
		 Array.prototype.slice.call(forms).forEach((form) => {
			form.addEventListener('submit', (event) => {
			 if (!form.checkValidity()) {
				event.preventDefault();
				event.stopPropagation();
			 }
			 form.classList.add('was-validated');
			}, false);
		 });
		})();
			
			
		});
		/* Fill guest details */
		
		
		document.addEventListener("DOMContentLoaded", function() {
			$('input[name="guest_details"]').on("change", function() {
				var selectedValue 	= $('input[name="guest_details"]:checked').val();
				var url 			= $('input[name="guest_details"]:checked').attr('data-url');
				
				 
				if (selectedValue == 'now') 
				{ 
					window.location.href = url;
					$('#guest_details_container').addClass('d-block').removeClass('d-none');
				}
				else
				{ 
					window.location.href = url;
					$('#guest_details_container').removeClass('d-block').addClass('d-none');
				} 
				$('#page-loader').removeClass('d-none');
			});
			
			//setTimeout(function() { $('input[name="guest_details"]').trigger('change');}, 300);
		});
					
	 
 
					
		document.addEventListener("DOMContentLoaded", function() {
			const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
			const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl)) 
		});


/* SEARCH */
document.addEventListener("DOMContentLoaded", function() {

	(function($) {
		$.extend({
			updateRoomNumber: function() {
				$('.repeater-item').each(function(index) {
					$(this).find('.room-number').text((index + 1));
				});

				var total = $('.repeater-item').length;

				if (total >= 9) {
					$('[data-repeater-create]').addClass('d-none').removeClass('d-block');
				} else {
					$('[data-repeater-create]').removeClass('d-none').addClass('d-block');
				}
			}
		});
	})(jQuery);
	(function($) {
		$.extend({
			submitSelection: function() {

				var check_out_date = $('#check_out_date').val();
				var check_in_date = $('#check_in_date').val();
				let formData = $('#total-room-selection').serializeArray();

				$('#page-loader').removeClass('d-none');
				$('#total-room-selection').submit();
			}
		});
	})(jQuery);
	(function($) {
		$.extend({
			validateRoomSelection: function() {
				return !$(".pax-selection-group").is(function() {
					return $(this).attr('valid') === 'false';
				});
			}
		});
	})(jQuery);
	(function($) {
		$.extend({
			refreshRoomSelection: function(group) {
				if ($(group).length) {

					var adult 		= parseInt($(group).find('.pax-adult').val(), 10) || 0;
					var child 		= parseInt($(group).find('.pax-child').val(), 10) || 0;
					var infant 		= parseInt($(group).find('.pax-infant').val(), 10) || 0;
					var infantFoc 	= parseInt($(group).find('.pax-infant-foc').val(), 10) || 0;
					
					var max = $(group).find('.pax-max-occupancy');
					var max_selected = (adult + child + infant + infantFoc);
					 

					if (max_selected > 6 || adult <= 0) {
						$(group).attr('valid', false);
						max.slideDown();
					} else {
						$(group).attr('valid', true);
						max.slideUp();
					}

				}
			}
		});
	})(jQuery);

	$("body").on("click", ".btn-prompt-message", function(event) {
		var msg = $(this).attr('data-msg');
		if (msg) {
			Swal.fire({
				text: msg,
				icon: "info",
				confirmButtonText: "OK",
				buttonsStyling: false,
				customClass: {
					confirmButton: 'btn btn-dark btn-selected-room bg-brand-primary-light-200 text-white',
				}
			});
		}

	});

	$("body").on("click", ".btn-plan-detail", function(event) {
		var url = $(this).attr('data-url');

		$.ajax({
			url: $.getUrlToken(url),
			type: 'POST',
			data: {},
			dataType: 'json',
			success: function(response) {

				if (response.status) {
					var html = Mustache.render($('#plan-detail-template').html(), {
						data: response.data
					});
					Swal.fire({
						html: html,
						confirmButtonText: 'OK',
						buttonsStyling: false,
						buttonsStyling: false,
						customClass: {
							confirmButton: 'btn btn-brand-dark me-1',
						}
					});
				}
			},
			error: function(xhr, status, error) {
				console.error(xhr, status, error);
			}
		});


	});

	$("body").on("click", ".btn-selected-room", function(event) {
		var url = $(this).attr('data-url');

		$.ajax({
			url: $.getUrlToken(url),
			type: 'POST',
			data: {},
			dataType: 'json',
			success: function(response) {

				Swal.fire({
					title: response.title,
					text: response.description,
					icon: "success",
					confirmButtonText: "OK",
					allowEscapeKey: false,
					allowOutsideClick: false,
					buttonsStyling: false,
					customClass: {
						confirmButton: 'btn btn-brand-dark', 
					}
				}).then((result) => {
					if (result.isConfirmed) {
						$('#page-loader').removeClass('d-none');


						if (response.next) {
							window.location.href = response.next;
						} else {
							window.location.reload();
						}

					}
				});

			},
			error: function(xhr, status, error) {
				console.error(xhr, status, error);
			}
		});


	});

	if ( $( ".total-room-selection" ).length ) 
	{
		$('.total-room-selection').repeater({
			initEmpty: false,
			isFirstItemUndeletable: true,

			show: function() {

				let currentItems = $('.total-room-selection [data-repeater-item]').length;

			 

				if (currentItems > 9) {
					$(this).remove();
					Swal.fire({
						text: "Maximum 9 Rooms allow per booking ",
						icon: "info",
						confirmButtonText: "OK",
						buttonsStyling: false,
						customClass: {
							confirmButton: 'btn btn-brand-dark',
						}
					});
					return;
				}

				$(this).slideDown();


				$(this).find('.pax-adult').val('2');
				$(this).find('.pax-child').val('0');
				$(this).find('.pax-infant').val('0');


				$.updateRoomNumber();
			},

			hide: function(deleteElement) {
				$(this).slideUp(function() {
					$(this).remove();
					$.updateRoomNumber();
				});
			},

			ready: function(setIndexes) {
				$.updateRoomNumber();
			}
		});

	}	

	$("body").on("change", ".pax-selection", function(event) {
		var group = $(this).closest('.pax-selection-group');
		$.refreshRoomSelection(group);
	});
	$("body").on("click", ".btn-apply-room", function(event) {
		if ($.validateRoomSelection()) {
			$.submitSelection();
			$(this).closest('.modal').modal('hide');
		}
	});
	$("body").on("click", ".btn-apply-date", function(event) {

		const initialValue = $('#double-date-picker').val();
		const dateRange = initialValue.split(' to ');
		const startDate = dateRange[0] ? dateRange[0].trim() : null;
		const endDate = dateRange[1] ? dateRange[1].trim() : null;

		if (startDate && endDate) {
			$('#check_in_date').val(startDate);
			$('#check_out_date').val(endDate);
			$.submitSelection();
			$(this).closest('.modal').modal('hide');
		}
	});
	$("body").on("click", ".btn-apply-plan", function(event) {

		var id = $(this).attr('data-id');
		if (id) {

			$('#rate').val(id);

			$.submitSelection();
			$(this).closest('.modal').modal('hide');
		}
	});




	$('.partial-hide').on('click', function() {
		$(this).toggleClass('expanded');
	});

	if ($("#double-date-picker").length) {
		const initialValue = $('#double-date-picker').val();
		const dateRange = initialValue.split(' - ');
		const startDate = new Date(dateRange[0]);
		const endDate = new Date(dateRange[1]);

		const formatDate = (date) => {
			const year = date.getFullYear();
			const month = ('0' + (date.getMonth() + 1)).slice(-2);
			const day = ('0' + date.getDate()).slice(-2);
			return `${year}-${month}-${day}`;
		};
		flatpickr($('#double-date-picker'), {
			mode: "range",
			minDate: "today",
			dateFormat: "Y-m-d",
			position: "below",
			inline: true,
			defaultDate: [formatDate(startDate), formatDate(endDate)],
			onReady: function(selectedDates, dateStr, instance) {
				const options = {
					year: 'numeric',
					month: 'short',
					day: 'numeric'
				};
			},
		});
	}
});


document.addEventListener("DOMContentLoaded", function() {
	if ( $( ".datepicker-future" ).length ) 
	{
		const $datepickerDisablePast = $('.datepicker-future');
		$datepickerDisablePast.each(function() { 
			var minDate = $(this).attr('data-min-date') || new Date().toISOString().split('T')[0];  
			new mdb.Datepicker(this, {
				disablePast: true,
				  min: new Date(minDate), setDate: new Date(minDate)
			});
		});

	}	
});


























/* COOKIE */

		document.addEventListener("DOMContentLoaded", function() {
			 

		(function ($) {
			$.extend({
				validateCookieConsent: function () {
				 
					if (!localStorage.getItem('cookieConsent')) 
					{
						$('#cookie-banner').removeClass('d-none').addClass('d-block');
					}	
				}
			});
		})(jQuery);
			
			$("body").on("click", "[data-cookie-preference]", function(event){
				var pref = $(this).attr('data-cookie-preference');
				
				if (pref == 'reject') 
				{
					localStorage.setItem('cookieConsent', 'rejected');
					$('#cookie-banner').removeClass('d-block').addClass('d-none');
				}
				else
				{
					localStorage.setItem('cookieConsent', 'accepted');
					$('#cookie-banner').removeClass('d-block').addClass('d-none');
				}
			});
			$.validateCookieConsent();
		});